export default [
  {
    name: "fullscreen",
    children: [
      {
        path: "/manage/demandorder",
        name: "demandorder",
        component: (resolve) => require(["./demandorder"], resolve),
      },
    ],
  },
];

// export default [
//   {
//     path: "/manage/demandorder",
//     name: "demandorder",
//     component: (resolve) => require(["./demandorder"], resolve),
//   },
// ];



// WEBPACK FOOTER //
// ./src/views/mall/demand/router.js